import { z } from "zod";
export const DECL_TYP_CODES = ["m", "f", "mk", "kk"];
export const DeclTypSchema = z.enum(DECL_TYP_CODES);
export const DECL_TYP_LABELS = {
    m: "nazwisko mężczyzny",
    f: "nazwisko kobiety",
    mk: "nazwisko małżeństwa",
    kk: "nazwisko kobiet",
};
export const DECL_HONORIFIC_ACC = {
    m: "Szanownego Pana",
    f: "Szanowną Panią",
    mk: "Szanownych Państwa",
    kk: "Szanowne Panie",
};
export const DeclensionFormsSchema = z.object({
    mianownik: z.string().min(1).max(120),
    dopelniacz: z.string().min(1).max(120),
    celownik: z.string().min(1).max(120),
    biernik: z.string().min(1).max(120),
    narzednik: z.string().min(1).max(120),
    miejscownik: z.string().min(1).max(120),
    wolacz: z.string().min(1).max(120),
});
export const DeclensionResponseSchema = z.object({
    nazwisko: z.string().min(1).max(60),
    typ: DeclTypSchema,
    forms: DeclensionFormsSchema,
});
export const INVITATION_CONTEXTS = ["koperta", "zaproszenie", "toast", "winietka"];
export const InvitationLinesSchema = z.object({
    koperta: z.string().min(1).max(240),
    zaproszenie: z.string().min(1).max(240),
    toast: z.string().min(1).max(240),
    winietka: z.string().min(1).max(240),
});
export const InvitationResponseSchema = z.object({
    nazwisko: z.string().min(1).max(60),
    typ: DeclTypSchema,
    imiona: z.array(z.string().min(1).max(40)).max(4),
    lines: InvitationLinesSchema,
    /** First names that were not found in the local dictionary (uninflected fallback). */
    unknownImiona: z.array(z.string()).default([]),
});
export const DECL_NAZWISKO_PATTERN = /^[A-Za-zĄĆĘŁŃÓŚŹŻąćęłńóśźż][A-Za-zĄĆĘŁŃÓŚŹŻąćęłńóśźż\- ]{0,59}$/u;
export const DECL_IMIE_PATTERN = /^[A-Za-zĄĆĘŁŃÓŚŹŻąćęłńóśźż][A-Za-zĄĆĘŁŃÓŚŹŻąćęłńóśźż-]{0,39}$/u;
export function isValidNazwisko(s) {
    return DECL_NAZWISKO_PATTERN.test(s);
}
export function isValidImie(s) {
    return DECL_IMIE_PATTERN.test(s);
}
export function normalizeNazwisko(s) {
    return s.normalize("NFC").trim().replace(/\s+/g, " ");
}
export function normalizeImie(s) {
    const cleaned = s.normalize("NFC").trim();
    if (!cleaned)
        return cleaned;
    return cleaned.charAt(0).toUpperCase() + cleaned.slice(1).toLowerCase();
}
